import React from 'react';
import "../styles/Layout.scss"
import {Outlet} from "react-router-dom";

const Layout = () => {
  return (
      <div id={"Layout"}>
        <Outlet/>
      </div>
  );
};

export default Layout;